import { render, staticRenderFns } from "./CustomerCharges.vue?vue&type=template&id=e8920758"
import script from "./CustomerCharges.vue?vue&type=script&lang=js"
export * from "./CustomerCharges.vue?vue&type=script&lang=js"
import style0 from "./CustomerCharges.vue?vue&type=style&index=0&id=e8920758&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports